module.exports = __webpack_public_path__ + "img/Painel 5.70652c04.jpg";